// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

interface TagAttributes {
  name: string | null;
  value: string | null;
}

class Tag extends Backbone.Model {
  _urlregex!: RegExp;
  _doiregex!: RegExp;
  _pmidregex!: RegExp;

  static initClass(): void {
    this.prototype._urlregex = /(https?:\/\/[^\s]+)/;
    // oxlint-disable-next-line no-useless-escape
    this.prototype._doiregex = /\b(?:doi:)(10[.][0-9]{4,}(?:[.][0-9]+)*\/(?:(?!["&\'])\S)+)\b/i; // from the source of JabRef
    this.prototype._pmidregex = /\bpmid:(\d{4,})\b/i;
  }
  override defaults(): TagAttributes {
    return {
      name: null,
      value: null,
    };
  }

  display(): string {
    if (this.get('value') != null) {
      return `${this.get('name')}:${this.get('value')}`;
    }
    return this.get('name');
  }

  renderValue($target: JQuery): this {
    // dumps a rendered tag into a given element

    const tagVal = this.get('value');
    if (tagVal != null) {
      // eslint-disable-next-line one-var
      let linkTag, m;
      if (this._urlregex.test(tagVal)) {
        linkTag = $('<a>').text(tagVal).attr('href', tagVal).attr('rel', 'nofollow');
        // @ts-expect-error: we sometimes pass a JQuery object to the html method
        $target.html(linkTag);
      }
      // eslint-disable-next-line benchlint/no-eqeqeq-null, no-cond-assign
      else if ((m = tagVal.match(this._doiregex)) !== null) {
        linkTag = $('<a>').text(tagVal).attr('href', `http://dx.doi.org/${m[1]}`);
        // @ts-expect-error: we sometimes pass a JQuery object to the html method
        $target.html(linkTag);
      }
      // eslint-disable-next-line benchlint/no-eqeqeq-null, no-cond-assign
      else if ((m = tagVal.match(this._pmidregex)) !== null) {
        linkTag = $('<a>').text(tagVal).attr('href', `http://pubmed.org/${m[1]}`);
        // @ts-expect-error: we sometimes pass a JQuery object to the html method
        $target.html(linkTag);
      } else {
        $target.text(tagVal);
      }
    }
    return this;
  }
}
Tag.initClass();

export default Tag;
